import { Profile, Team } from "@brg/api";
import { bProfile, ProfileRole } from "@brg/auth";
import { HsePolicies } from "shared/constants/HsePolicies";

export const canEditTeamForm = (profile: Profile, team: Team<'Global'>) => {
    const isTeamOwner = team.ownersIDs?.includes(profile.accountId);
    const isSuperModer = bProfile.isModer(profile);
    const isSuperManager = profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.can_supervise_external_teams)).containsIn(profile.rolesList);
    const isUiAdmin = profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.access_ui_content_admin)).containsIn(profile.rolesList);
    const isTeamShowcaseAdmin = profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.team_showcase_admin_prefix + team.teamId)).containsIn(profile.rolesList);
    const isTeamUnitAdmin = profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.admin_unit_prefix + team.teamId)).containsIn(profile.rolesList);

    return isTeamOwner || isSuperModer || isSuperManager || isUiAdmin || isTeamShowcaseAdmin || isTeamUnitAdmin;
}import { Profile, Team } from "@brg/api";
import { bProfile, ProfileRole } from "@brg/auth";
import { HsePolicies } from "shared/constants/HsePolicies";

export const canEditTeamForm = (profile: Profile, team: Team<'Global'>) => {
    const isTeamOwner = team.ownersIDs?.includes(profile.accountId);
    const isSuperModer = bProfile.isModer(profile);
    const isSuperManager = profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.can_supervise_external_teams)).containsIn(profile.rolesList);
    const isUiAdmin = profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.access_ui_content_admin)).containsIn(profile.rolesList);
    const isTeamShowcaseAdmin = profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.team_showcase_admin_prefix + team.teamId)).containsIn(profile.rolesList);
    const isTeamUnitAdmin = profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.admin_unit_prefix + team.teamId)).containsIn(profile.rolesList);

    return isTeamOwner || isSuperModer || isSuperManager || isUiAdmin || isTeamShowcaseAdmin || isTeamUnitAdmin;
}